import { ref } from "vue"
import router from "../router/router"
import api from "../composables/useApi"
import { useUserProfiles } from "../composables/useUserProfile"
import { useTimestampStore } from "../stores/timestamps"
import { useTeaserStore } from "../stores/teaser"
import { extractDurationFromKwik } from "../utils/media"
import { url } from "../helper"
import { useI18n } from "vue-i18n"

export function usePlay() {
	const selectedEpisodeNid = ref<number>(0)

	const { fetchVideoFlagStoreByProfile } = useUserProfiles()
	const timestampStore = useTimestampStore()
	const teaserStore = useTeaserStore()
	const { locale } = useI18n()

	const playElement = async (item: any) => {
		let entityType = ""
		let nextEpisodeId: string | null = null
		let time: number | undefined = undefined
		let duration = 0

		const entityId = item.type === "node--movie" ? item.id : undefined
		const parentId = item?.type === "node--series" ? item.id : undefined

		let flag: string | undefined = item?.type === "node--movie" ? "started" : undefined

		const res = await fetchVideoFlagStoreByProfile(
			entityId,
			item.type === "node--movie" ? "movie" : "episode",
			flag,
			parentId
		)

		if (res.length && res[0].video_flag_type === "completed") {
			// fetch next episode
			const episodesRes = await api.get(`/jsonapi/node/episode`, {
				params: {
					"filter[field_series.id]": parentId,
					fields: "drupal_internal__nid",
				},
			})

			const episodes = episodesRes.data.data.map((ep: any) => ep.attributes.drupal_internal__nid)

			const currentId = res[0]?.target_entity.drupal_internal__nid
			const currentIndex = episodes.indexOf(currentId)

			if (currentIndex >= 0 && currentIndex < episodes.length - 1) {
				nextEpisodeId = episodes[currentIndex + 1]

				const epRes = await api.get(
					`${locale.value}/jsonapi/node/episode?jsonapi_include=1&include=field_trailer_file,field_image,field_series,field_series.field_image,field_subtitles,field_subtitles.field_subtitle_file`,
					{
						params: {
							"filter[drupal_internal__nid]": nextEpisodeId,
							"filter[langcode]": locale.value,
							"filter[status]": 1,
						},
					}
				)

				selectedEpisodeNid.value = epRes.data.data[0].drupal_internal__nid
			}
		} else if (res.length === 0 && parentId) {
			// first episode start
			const firstEp = await api.get(`${url}/jsonapi/node/episode`, {
				params: {
					"filter[field_series.id]": parentId,
					page: { limit: 1 },
				},
			})

			if (firstEp.data.data?.length) {
				selectedEpisodeNid.value = firstEp.data.data[0].attributes.drupal_internal__nid
			}
		} else {
			// resume case
			duration = extractDurationFromKwik(res[0]?.target_entity?.field_kwik_data) ?? 0
			time = res[0]?.timestamp
			if (res[0]?.target_entity_type === "episode") {
				selectedEpisodeNid.value = res[0]?.target_entity?.drupal_internal__nid
			}
			if (time) timestampStore.addTimestamp(time, "episode", selectedEpisodeNid.value!)
		}
	}

	return {
		playElement,
		selectedEpisodeNid,
	}
}
